<template>
  <div>The next phase's update plan</div>
</template>

<script>
export default {};
</script>

<style>
</style>